export enum logType {
    Info,
    Warn,
    Error,
    Fatal
}

export const useLog = async (type: logType, message: string) => {
	const myHeaders = new Headers();
	myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

	const requestOptions: any = {
		method: 'POST',
		headers: myHeaders,
		redirect: 'follow'
	};

	await fetch(`/api/LoggingApi/${logType[type]}?message=` + message, requestOptions)
		.then(response => {
			if (!response.ok) {
				throw new Error('Failed to fetch');
			}

		})
		.catch((err) => {
			console.error('Error logging ' + err);
		});
};
